import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { TableCell } from './tableCell';
import Comment from './Comment.jsx/Comment';
import { getGradeValue, setClassbook } from '../../actions/classbook';
import { useDispatch } from 'react-redux';
import ModalTheme from './ModalTheme/ModalTheme';
import { ClassbookContext } from '../../utils/context';

const ClassbookTable = ({ classbook, handleClassTopic, lesson_chart }) => {

  const { formData, selected, setSelected } = useContext(ClassbookContext);

  const getUniqueDateOfPeriod = (options) => {
    return options.reduce(
      (res, cur) =>
        res.find((find) =>
          JSON.stringify(find.lessonunixdate) === JSON.stringify(cur.lessonunixdate)
          && JSON.stringify(find.instance) === JSON.stringify(cur.instance)
          && JSON.stringify(find.sheid) === JSON.stringify(cur.sheid)
          && JSON.stringify(find.lessonid) === JSON.stringify(cur.lessonid)
        )
          ? res
          : [...res, cur],
      []
    ).sort((a, b) => a - b);
  };

  const forListOfDates = (getUniqueDateOfPeriod(classbook))
  // const listOfDates = [...( (forListOfDates.sort((a,b) => a.instance - b.instance)).slice(1)),forListOfDates.find(el => el.lessondate === 'Ср. балл' || el.lessondate === 'Учебный период')]
  const listOfDates1 = forListOfDates.filter(el => el.sheid !== 0)
  const listOfDates2 = forListOfDates.filter(el => el.sheid === 0)
  const listOfDates = [...listOfDates1, ...listOfDates2]


  const uniqStud = (options) => {
    return options.reduce(
      (res, cur) =>
        res.find((find) => JSON.stringify(find.mid) === JSON.stringify(cur.mid))
          ? res
          : [...res, cur],
      []
    )
  };

  const dispatch = useDispatch();

  //TODO 
  const listStudent = (uniqStud(classbook).filter((el) => el.mid !== 99999))
  const avBall = uniqStud(classbook).find((el) => el.mid === 99999) || {}
  const listAll = [...listStudent, avBall]


  const originalStudentMax = ((listAll.map((el, i) => classbook.filter((student) => student?.mid === el?.mid)).sort((a, b) => b.length - a.length)))[0]

  const [modalData, setModalData] = useState(null);
  const [panelOpen, setPanelOpen] = useState({ mid: null, lessonid: null });
  const [commentOpen, setCommentOpen] = useState({ mid: null, lessonid: null });
  const [columnGradeOpen, setColumnGradeOpen] = useState(false);
  const [columnGradeValue, setColumnGradeValue] = useState('');
  const [averagesBySheid, setAveragesBySheid] = useState({});
  const [averagesByMid, setAveragesByMid] = useState({});

  // Функция расчёта среднего балла для sheid (колонка)
  const calculateAvgForSheid = (data, sheid) => {
    const grades = data
      .filter(item => item.sheid === sheid && item.mid !== 99999)
      .map(item => item.grade)
      .filter(grade => grade)
      .flatMap(grade => String(grade).split('').map(Number))
      .filter(n => n >= 1 && n <= 5);

    return grades.length > 0
      ? (grades.reduce((sum, g) => sum + g, 0) / grades.length).toFixed(2)
      : '';
  };

  // Функция расчёта среднего балла для студента (mid)
  const calculateAvgForStudent = (data, mid) => {
    const grades = data
      .filter(item => item.mid === mid && item.lessondate !== 'Ср. балл' && item.sheid !== 0)
      .map(item => item.grade)
      .filter(grade => grade)
      .flatMap(grade => String(grade).split('').map(Number))
      .filter(n => n >= 1 && n <= 5);

    return grades.length > 0
      ? (grades.reduce((sum, g) => sum + g, 0) / grades.length).toFixed(2)
      : '';
  };

  // Инициализация средних при загрузке classbook
  useEffect(() => {
    if (classbook.length > 0) {
      // Средние по sheid (для строки "Ср. балл")
      const uniqueSheids = [...new Set(classbook.map(item => item.sheid).filter(s => s))];
      const sheidAvgs = {};
      uniqueSheids.forEach(sheid => {
        sheidAvgs[sheid] = calculateAvgForSheid(classbook, sheid);
      });
      setAveragesBySheid(sheidAvgs);

      // Средние по mid (для колонки "Ср. балл" в Итогах)
      const uniqueMids = [...new Set(classbook.map(item => item.mid).filter(m => m && m !== 99999))];
      const midAvgs = {};
      uniqueMids.forEach(mid => {
        midAvgs[mid] = calculateAvgForStudent(classbook, mid);
      });
      setAveragesByMid(midAvgs);
    }
  }, [classbook]);

  // Callback для обновления средних при изменении оценки
  const updateSheidAverage = (sheid, newGrade, mid, lessonid) => {
    const updatedData = classbook.map(item =>
      (item.mid === mid && item.lessonid === lessonid)
        ? { ...item, grade: newGrade }
        : item
    );
    // Обновить средний по sheid
    const newSheidAvg = calculateAvgForSheid(updatedData, sheid);
    setAveragesBySheid(prev => ({ ...prev, [sheid]: newSheidAvg }));
    // Обновить средний по студенту
    const newMidAvg = calculateAvgForStudent(updatedData, mid);
    setAveragesByMid(prev => ({ ...prev, [mid]: newMidAvg }));
  };

  const openModal = (data) => setModalData(data);
  const closeModal = () => setModalData(null)

  const handleOpenModal = (data) => {
    handleClassTopic(formData.scYear, data.sheid);
    const chartEntry = lesson_chart?.find(item => item.sheid === data.sheid);
    openModal({
      ...data,
      sh_mod_fact_id: chartEntry?.sh_mod_fact_id,
      hw_text_j: chartEntry?.hw_text_j || '',
      has_topic: chartEntry?.has_topic || !!chartEntry?.topic_text_j,
      lessonfulldate: chartEntry?.lessonfulldate || data.lessondate,
      grpname: chartEntry?.grpname || '',
    });
  }

  const lessonsType = {
    '': '?',
    'Урок': '★',
    'Контрольная работа': 'КР',
  }

  const romanNum = {
    1: 'I',
    2: 'II',
    3: 'III',
    4: 'IV',
  }

  let count = 0;

  const getMarkType = (day) => {
    const chartEntry = lesson_chart?.find(item => item.sheid === day.sheid);
    if (chartEntry?.has_topic || chartEntry?.topic_text_j) return '★';
    const type = day.lessontype;
    if (!type || type === '') return '?';
    return lessonsType[type] ?? type.substring(0, 2);
  };

  const getActiveSell = (val) => classbook.find((student) => (student.mid) == val?.mid && (student.lessonid == val?.lessonid));

  const postComment = (value) => {
    if (selected.length > 1) {
      selected.forEach(sel => {
        const cell = getActiveSell(sel) ||
          (sel.mid === commentOpen.mid && sel.lessonid === commentOpen.lessonid
            ? commentOpen.student : null);
        if (cell) dispatch(setClassbook({ ...cell, gradecomment: value }, formData));
      });
    } else {
      const cell = getActiveSell(commentOpen) || commentOpen.student;
      if (cell) dispatch(setClassbook({ ...cell, gradecomment: value }, formData));
    }
    setCommentOpen({ mid: null, lessonid: null });
  }

  const handleActive = ({ mid, lessonid }) => {
    if (panelOpen.mid && panelOpen.lessonid) {
      setPanelOpen({ mid: null, lessonid: null });
    } else if (selected.find(el => (el.mid == mid) && (el.lessonid == lessonid))) {
      setSelected([]);
    } else {
      setSelected([{ mid: mid, lessonid: lessonid }]);
    }
  }

  const checkPeiod = (el) => el === 'Учебный период';

  // Фильтрованный список дат (без Год, экз, итог)
  const filteredListOfDates = listOfDates.filter(day =>
    day.lessondate !== 'Год' &&
    !day.lessondate.toLowerCase().includes('экз') &&
    !day.lessondate.toLowerCase().includes('итог')
  );

  // Подсчёт количества итоговых столбцов (всё кроме обычных дат уроков)
  const regularDatesCount = listOfDates.filter(day => day.lessonunixdate < 9999999999).length;
  const colSpan = filteredListOfDates.length - regularDatesCount;

  useEffect(() => {
    dispatch(getGradeValue())
  }, [])

  return (
    <>
      {classbook.length == 0 ?
        <div className={styles.table}>Выберите параметры</div>
        :
        (
          <div className={styles.wrapper}>
            <div className={styles.tableWrapper}>

              {commentOpen.mid ? <Comment data={getActiveSell(commentOpen)?.gradecomment ?? commentOpen.student?.gradecomment} setCommentOpen={setCommentOpen} postComment={postComment} /> : <></>}

              <div className={styles.tableHeader}>
                <span className={styles.tableLabel}>Журнал успеваемости и посещаемости</span>
                <span className={styles.tableHint}>✦ клик по дате/типу — тема занятия</span>
                <span className={styles.tableHintRight}>Enter/клик по ячейке — оценка</span>
              </div>

              <table>
                <>
                  <thead>
                    <tr>
                      <td rowSpan={2} className={styles.numCol}>№ п.п.</td>
                      <td rowSpan={2} style={{ textAlign: "center" }}>Фамилия И.О.</td>
                      {listOfDates.length &&
                        listOfDates.map((day, i) => (day.lessonunixdate < 9999999999) ?
                          <td
                            key={i}
                            onClick={() => handleOpenModal(day)}
                            className={styles.headerDateCell}
                          >
                            {getMarkType(day)}
                          </td>
                          :
                          ''
                        )
                      }
                      {colSpan > 0 && <td style={{ textAlign: 'center' }} colSpan={colSpan}>Итоги</td>}
                    </tr>
                    <tr className={styles.classes}>
                      {filteredListOfDates &&
                        filteredListOfDates.map((day, i) => {
                          if (checkPeiod(day.lessondate)) { count = count + 1 };
                          return <td key={i} style={{ textAlign: 'center' }}>
                            {checkPeiod(day.lessondate) ? romanNum[count] : day.lessondate}
                          </td>
                        })}
                    </tr>
                    <tr>
                      <td colSpan={filteredListOfDates.length + 2} className={styles.scrollHint}>
                        → прокрутите для просмотра всех дат
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {listAll.length &&
                      listAll.map((el, i) => {
                        const allStudentGrades = classbook.filter((student) => student.mid === el.mid)

                        return (
                          <tr>
                            {el?.student !== "Ср. балл" ?
                              <td className={styles.numCol}>{i + 1}</td>
                              :
                              <td></td>
                            }
                            <td
                              className={styles.student}
                              style={{ textAlign: "left", fontSize: '13px' }}
                            >{el?.student}</td>
                            {filteredListOfDates.map((day, i) => {
                              const { lessondate, sheid, lessonid, lessonunixdate } = day;
                              let grade = allStudentGrades.find((g) => g.lessondate === lessondate && g.sheid === sheid);
                              // Для строки "Ср. балл" использовать averagesBySheid
                              if (el?.student === "Ср. балл") {
                                return <td key={i} style={{ textAlign: 'center' }}>
                                  {averagesBySheid[sheid] || grade?.grade || ''}
                                </td>
                              }
                              // Для колонки "Ср. балл" использовать averagesByMid
                              if (lessondate === "Ср. балл") {
                                return <td key={i} style={{ textAlign: 'center' }}>
                                  {averagesByMid[el.mid] || grade?.grade || ''}
                                </td>
                              }
                              const teacherEntry = !grade ? classbook.find(item => item.sheid === sheid && item.lessonid === lessonid) : null;
                              const studentObj = grade || {
                                mid: el.mid,
                                student: el.student,
                                teachermid: teacherEntry?.teachermid || el.teachermid,
                                teachermids: teacherEntry?.teachermids || el.teachermids,
                                lessonid,
                                lessondate,
                                sheid,
                                lessonunixdate,
                                grade: null,
                                gradecomment: null,
                                gradeweight: 1,
                              };
                              return <TableCell
                                key={i}
                                classbook={classbook}
                                mark={studentObj.grade}
                                student={studentObj}
                                panelOpen={panelOpen}
                                setPanelOpen={setPanelOpen}
                                formData={formData}
                                commentOpen={commentOpen}
                                setCommentOpen={setCommentOpen}
                                setClassbook={setClassbook}
                                getActiveSell={getActiveSell}
                                selected={selected}
                                setSelected={setSelected}
                                handleActive={handleActive}
                                updateSheidAverage={updateSheidAverage}
                                onColumnSelected={() => setColumnGradeOpen(true)}
                              />;
                            })}
                          </tr>
                        )
                      }
                      )

                    }
                  </tbody>
                </>

              </table>

              {<ModalTheme modalData={modalData} setModalData={setModalData} closeModal={closeModal} formData={formData} />}

              <div class={styles.line}></div>

            </div>

            {columnGradeOpen && (
              <div className={styles.columnGradeOverlay} onClick={() => { setColumnGradeOpen(false); setColumnGradeValue(''); }}>
                <div className={styles.columnGradeModal} onClick={e => e.stopPropagation()}>
                  <div className={styles.columnGradeTitle}>
                    Выставить оценку — {selected.length} {selected.length === 1 ? 'ячейка' : 'ячеек'}
                  </div>

                  <div className={styles.columnGradeInputRow}>
                    <input
                      autoFocus
                      type="text"
                      maxLength={5}
                      value={columnGradeValue}
                      placeholder="Введите оценку"
                      className={styles.columnGradeInput}
                      onChange={e => {
                        const val = e.target.value;
                        if (val === '' || /^[1-5нНhH]{0,5}$/.test(val)) setColumnGradeValue(val);
                      }}
                      onKeyDown={e => {
                        if (e.key === 'Enter' && columnGradeValue) {
                          selected.forEach(sel => {
                            const target = classbook.find(c => c.mid === sel.mid && c.lessonid === sel.lessonid);
                            if (target) dispatch(setClassbook({ ...target, teachermid: target.teachermid || target.teachermids, gradeweight: target.gradeweight || 1, grade: columnGradeValue }, formData));
                          });
                          setColumnGradeOpen(false);
                          setColumnGradeValue('');
                        }
                        if (e.key === 'Escape') { setColumnGradeOpen(false); setColumnGradeValue(''); }
                      }}
                    />
                    <button
                      className={styles.columnGradeApply}
                      disabled={!columnGradeValue}
                      onClick={() => {
                        selected.forEach(sel => {
                          const target = classbook.find(c => c.mid === sel.mid && c.lessonid === sel.lessonid);
                          if (target) dispatch(setClassbook({ ...target, teachermid: target.teachermid || target.teachermids, gradeweight: target.gradeweight || 1, grade: columnGradeValue }, formData));
                        });
                        setColumnGradeOpen(false);
                        setColumnGradeValue('');
                      }}
                    >
                      Применить
                    </button>
                  </div>

                  <button
                    className={styles.columnGradeCancel}
                    onClick={() => {
                      selected.forEach(sel => {
                        const target = classbook.find(c => c.mid === sel.mid && c.lessonid === sel.lessonid);
                        if (target) dispatch(setClassbook({ ...target, teachermid: target.teachermid || target.teachermids, gradeweight: target.gradeweight || 1, grade: null }, formData));
                      });
                      setColumnGradeOpen(false);
                      setColumnGradeValue('');
                    }}
                    style={{ color: '#e74c3c', borderColor: '#e74c3c' }}
                  >
                    Удалить оценки
                  </button>

                  <button className={styles.columnGradeCancel} onClick={() => { setColumnGradeOpen(false); setColumnGradeValue(''); }}>
                    Отмена
                  </button>
                </div>
              </div>
            )}

          </div>
        )}
    </>

  )
}

export default ClassbookTable;